module.exports = __webpack_public_path__ + "96294395cd72f24072833f99a693a57b.pdf";